(function($){
$(document).ready(function() {

    var alert_mess = new Object();
    $.ajax({
        url: '/xhr-actions/get_alerts_message',
            success: function(valeur) {
            alert_mess = JSON.parse(valeur);
        }
    });

    $('input[accept]').change(function() {
        verify($(this));
    });

    $('body').on('blur', '[data-verify], [data-required]', function(){
        var elt = $(this);
        verify(elt);
    });


    $('body').on('submit', 'form', function() {
        var form = $(this);
        if(!form.hasClass('form-validable')) {
          if (test_form(form) === 0){
              return true;
          }
          else{
              affiche_erreurs();
              scrollTo(0,0);
              return false;
          }
        }
    });

    var form_errors = new Array();

    function valeur_elt(elt){
        var type = elt.attr('type');
        switch(type){
            case 'checkbox':
            case 'radio':
                var name = elt.attr('name');
                var val = $('input[name="'+name+'"]:checked').val();
                if (typeof val === "undefined") val = false;
            break;

            default:
                var val = (elt.val() != '') ? elt.val() : false;
                break;
        }
        return val;
    }

    function affiche_erreur(name, msg, elt_for_span, elt_for_class){
        if (elt_for_class === undefined) elt_for_class = elt_for_span;
        var span_error = '<span class="field-error">' + msg + '</span>';
        elt_for_span.after(span_error);
        elt_for_class.addClass('has-error');

        //name = elt_for_span.attr("name");
        elt_name = (alert_mess.label[name] === undefined) ? name : alert_mess.label[name];

        form_errors.push({
            msg: msg,
            elt_name: elt_name
        });
    }

    function affiche_erreurs(){
        $('.validation_erreurs').html('<ul></ul>');
        ul_errors = $('.validation_erreurs ul');
        $.each(form_errors, function(index,item){
            elt_name = item.elt_name.substr(0,1).toUpperCase()+item.elt_name.substr(1);
            ul_errors.append('<li><strong>'+elt_name+' :</strong> '+item.msg+'</li>');
        })
        $('.validation_erreurs').show();
    }

    function email_valide(email) {
        var reg = new RegExp('^[a-z0-9]+([_\\-.+]{1}[a-z0-9]+)*@[a-z0-9]+([_|\\.|-]{1}[a-z0-9]+)*[\\.]{1}[a-z]{2,}$', 'i');
        return(reg.test(email));
    }

    function file_valide(elt) {
        var file_extension = elt.val().match(/\.([^\.]+)$/)[1].toLowerCase(),
            allowed_extensions = new RegExp(elt.attr('accept').replace(/,/g, "$|^").replace(/\./g, "").toLowerCase());
        if (file_extension.match(allowed_extensions)) {
            return true;
        } else {
            elt.val("");
            return false;
        };
    }

    function date_format_fr(ladate) {
        // Valide une string au format JJ/MM/AAAA
        // http://regexr.com/3gfcg
        // lister les séparateurs autorisés à la suite, exple : '/ -.'
        var sep = '/';
        var reg = new RegExp('^\\d{2}['+sep+']\\d{2}['+sep+']\\d{4}$');
        return reg.test(ladate);
    }

    function date_valide(ladate) {
        // Valide une date existante au format JJ/MM/AAAA en prenant en compte les années bissextiles
        // http://regexr.com/3gfbl
        // lister les séparateurs autorisés à la suite, exple : '/ -.'
        var sep = '/';
        var reg = new RegExp('^(((0[1-9]|[12][0-9]|3[01])['+sep+'](0[13578]|1[02])|(0[1-9]|[12][0-9]|30)['+sep+'](0[469]|11)|(0[1-9]|1\\d|2[0-8])['+sep+']02)['+sep+']\\d{4}|29['+sep+']02['+sep+'](\\d{2}(0[48]|[2468][048]|[13579][26])|([02468][048]|[1359][26])00))$');
        return reg.test(ladate);
    }

    function cp_valide(cp) {
        var reg = new RegExp(/^[0-9]{5}$/);
        return(reg.test(cp) && cp != '00000');
    }

    function password_valide(pwd) {
        // http://regexr.com/3bfsi
        var reg = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/);
        pwd = pwd.trim();
        return(reg.test(pwd));
    }

    function nom_formate(elt, nom) {
        elt.val(nom.toUpperCase());
    }

    function tel_formate(tel) {
        var reg = new RegExp(/^([0+(]{1})(([\d+() .-]){5,18})([+(\d]{1})$/);
        return reg.test(tel);
    }

    function quel_age(date_naissance) {
        // date_naissance au format JJ/MM/AAAA;
        var day = new Date(date_naissance.substr(-4), date_naissance.substr(3,2)-1, date_naissance.substr(0,2));
        var annee_naissance = day.getFullYear();
        var mois_naissance  = day.getMonth();
        var jour_naissance  = day.getDate();

        var today = new Date();
        var annee = today.getFullYear();
        var mois  = today.getMonth();
        var jour  = today.getDate();

        age = annee - annee_naissance;
        if ( mois_naissance > mois || (mois_naissance == mois && jour_naissance > jour)) {
            age--;
        }
        return age;
    }

    function checkRequired(elt){
        var isRequired = elt.data('required');
        var has_error = false;
        var valeur = valeur_elt(elt);
        if (isRequired && !valeur){
            has_error = true;
            var msg_error = alert_mess.required;
        }
    }

    function verify(elt){
        var type = elt.data('verify'),
            isRequired = elt.data('required');

        var has_error = false;
        var valeur = valeur_elt(elt);

        if(elt.attr('type')=='radio'){
            elt.parents('.has-error').siblings('.field-error').remove();
            elt.parents('.has-error').removeClass('has-error');
        }
        else{
            elt.siblings('.field-error').remove();
            elt.removeClass('has-error');
        }

        if (valeur !== false) {
            res = test_input(type, elt, valeur);
            has_error = res[0];
            msg_error = res[1];
            if (msg_error == '')
                msg_error = alert_mess[type];
        }
        else{
            if (type == 'pass2'){
                pass1 = elt.parents('form').find('[data-verify="pass"]').val();
                has_error = (pass1 != valeur);
                msg_error = alert_mess[type];
            }
            if (isRequired && !valeur){
                has_error = true;
                msg_error = alert_mess.required;
            }
        }

        if (has_error) {
            elt_for_span = elt;
            name = elt_for_span.attr("name");
            if (elt.attr('type')=='radio' || elt.attr('type')=='checkbox') {
                elt_for_span = elt.parents('div').first();
                name = elt_for_span.find('input').attr("name");
              }
            affiche_erreur(name, msg_error, elt_for_span);
        }

        return has_error;
    }

    function test_input(type, elt, valeur) {
        erreur_msg = '';
        has_error = false;
        switch(type){
            case 'nom':
                nom_formate(elt,valeur);
            break;
            case 'prenom':
                prenom_formate(elt,valeur);
            break;
            case 'cp':
                has_error = !cp_valide(valeur);
            break;
            case 'email':
                has_error = !email_valide(valeur);
            break;
            case 'date_naiss':
                if (has_error = !date_format_fr(valeur)){
                    erreur_msg = alert_mess.date_format_fr;
                }
                else if (has_error = !date_valide(valeur)){
                    erreur_msg = alert_mess.date_valide;
                }
                else {
                    var age = quel_age(valeur);
                    var isJAMajeure = elt.parents('form').is('.majeure');
                    if(!isJAMajeure)
                      isJAMajeure = elt.parents('form').is('.JAM');
                    console.log("isJAMajeure : "+isJAMajeure);
                    var isMembre = elt.parents('.liste_fiches').is("#membres");
                    if(!isMembre && $('input[name="type"]:checked').val()=="Membre")
                      isMembre = true;
                    var isRepresentant = elt.parents('.liste_fiches').is("#representants");
                    if(!isRepresentant && $('input[name="type"]:checked').val()=="Representant")
                      isRepresentant = true;
                    console.log("isRepresentant : "+isRepresentant);
                    if (isMembre && (has_error = (age < 5 || age > 21))){
                        erreur_msg = alert_mess.age_membre;
                    }
                    else if (isRepresentant && !isJAMajeure && (has_error = (age < 5 || age >= 18))){
                        erreur_msg = alert_mess.age_repres;
                    }
                    else if (isRepresentant && isJAMajeure && (has_error = (age < 18 || age > 20))){
                        erreur_msg = alert_mess.age_repres_ja_majeure;
                    }
                    //console.log('erreur_msg : '+erreur_msg+age);
                }
            break;
            case 'pass':
                has_error = !password_valide(valeur);
            break;
            case 'pass2':
                var pwd = elt.parents('form').find('input[name="motdepasse"]').val();
                has_error = !(valeur === pwd);
            break;
            case 'pj[logo]':
                if (has_error = !file_valide(elt)){
                    erreur_msg = alert_mess.file;
                }
            break;
            case 'tel':
                has_error = !tel_formate(valeur);
            break;
            default:
                has_error = false;
        }

        return new Array(has_error, erreur_msg);
    }

    function test_form(form) {
        var nb_erreur = 0;
        form_errors = new Array();
        form.find('[data-verify], [data-required]').each(function(){
            var elt = $(this);
            if (verify(elt) != false) nb_erreur++;
        })

        return nb_erreur;
    }
}); // document.ready


})(jQuery);